import { resolveConversionAction } from "../conversion-actions.js";
import { attr, text, url } from "./escape.js";

interface RenderConversionActionInput {
  props: Record<string, unknown>;
  label: string;
  className: string;
  defaultUrl: string;
  componentType: string;
  componentId?: string;
  closePopupOnClick?: boolean;
}

const PLATFORM_ACTION_RUNTIME = `<script>(function(){if(window.__easePlatformActionRuntimeBound)return;window.__easePlatformActionRuntimeBound=true;document.addEventListener('click',function(event){var target=event.target instanceof Element?event.target.closest('[data-ease-platform-action=\"true\"]'):null;if(!target)return;var payload={};try{payload=JSON.parse(target.getAttribute('data-ease-action-payload')||'{}');}catch{}var detail={actionRef:target.getAttribute('data-ease-action-ref')||'',payload:payload,fallbackUrl:target.getAttribute('data-ease-fallback-url')||null,componentId:target.getAttribute('data-ease-component-id')||null,componentType:target.getAttribute('data-ease-component-type')||null,analyticsTouchpoint:target.getAttribute('data-ease-analytics-touchpoint')||'declared_platform_action',conversionSemantics:target.getAttribute('data-ease-conversion-semantics')||'platform_action_request_not_measured'};var actionEvent=new CustomEvent('ease:conversion-action',{bubbles:true,cancelable:true,detail:detail});target.dispatchEvent(actionEvent);document.dispatchEvent(new CustomEvent('ease:analytics-touchpoint',{bubbles:true,detail:detail}));if(target.getAttribute('data-ease-close-popup')==='true'){var popup=target.closest('[data-ease-popup]');if(popup)popup.setAttribute('hidden','');}if(actionEvent.defaultPrevented)return;var fallbackUrl=target.getAttribute('data-ease-fallback-url');if(fallbackUrl)window.location.assign(fallbackUrl);});})();</script>`;

export function renderConversionActionControl(input: RenderConversionActionInput): string {
  const action = resolveConversionAction(input.props, input.defaultUrl);
  const commonAttrs = [
    `class="${attr(input.className)}"`,
    `data-ease-analytics-touchpoint="${attr(action.analyticsTouchpoint)}"`,
    `data-ease-conversion-semantics="${attr(action.conversionSemantics)}"`,
    input.componentId ? `data-ease-component-id="${attr(input.componentId)}"` : "",
    `data-ease-component-type="${attr(input.componentType)}"`,
    input.closePopupOnClick ? 'data-ease-close-popup="true"' : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (action.kind === "navigate") {
    const targetAttrs = action.openInNewTab
      ? ' target="_blank" rel="noopener noreferrer"'
      : "";

    return `<a href="${url(action.url)}" ${commonAttrs}${targetAttrs}>${text(input.label)}</a>`;
  }

  const payload = JSON.stringify(action.payload);
  const fallbackAttr = action.fallbackUrl
    ? ` data-ease-fallback-url="${attr(action.fallbackUrl)}"`
    : "";

  return `<button type="button" ${commonAttrs} data-ease-platform-action="true" data-ease-action-ref="${attr(action.actionRef)}" data-ease-action-payload="${attr(payload)}"${fallbackAttr}>${text(input.label)}</button>${PLATFORM_ACTION_RUNTIME}`;
}
